import Link from 'next/link';
import Image from 'next/image';
import { useRouter } from 'next/router';
import styles from '../styles/CalculatorTabs.module.css';

// static imports of the PNGs inside src/images/icons/
import uvalueIcon from '../images/icons/uvalue.png';
import varmetabIcon from '../images/icons/varmetab.png';
import savingsIcon from '../images/icons/savings.png';

const tabs = [
    { label: 'U-værdi', href: '/uvalue', icon: uvalueIcon },
    { label: 'Varmetabsramme', href: '/varmetab', icon: varmetabIcon },
    { label: 'Årlig besparelse', href: '/savings', icon: savingsIcon },
];

export default function TabbedCalculators() {
    const { pathname } = useRouter();

    return (
        <nav className={styles.tabnav}>
            {tabs.map(({ href, label, icon }) => {
                const isActive = pathname === href;
                return (
                    <Link key={href} href={href} legacyBehavior>
                        <a className={`${styles.tablink} ${isActive ? styles.active : ''}`}>
                            <Image
                                src={icon}
                                alt={`${label} ikon`}
                                width={32}
                                height={32}
                                className={`${styles.tabIcon} ${isActive ? styles.activeIcon : ''}`}
                            />
                            <span>{label}</span>
                        </a>
                    </Link>
                );
            })}
        </nav>
    );
}
